"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.RangeInputControl = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("../index"));

var _validator = _interopRequireDefault(require("./validator"));

var _EventHandler = _interopRequireDefault(require("./EventHandler"));

var _Input = _interopRequireDefault(require("./components/Input"));

var _Track = _interopRequireDefault(require("./components/Track"));

var _Ticks = _interopRequireDefault(require("./components/Ticks"));

var _Handle = _interopRequireDefault(require("./components/Handle"));

var _createRangeSteps = _interopRequireDefault(require("./helpers/createRangeSteps"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RangeInputControl = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RangeInputControl, _Component);

  var _super = _createSuper(RangeInputControl);

  function RangeInputControl(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, RangeInputControl);
    _this = _super.call(this, props);
    _this.steps = [];
    _this.trackId = /*#__PURE__*/_react["default"].createRef();
    _this.handleId = /*#__PURE__*/_react["default"].createRef();
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(RangeInputControl, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          fieldData = _this$props.fieldData,
          eventHandler = _this$props.eventHandler,
          storedValue = _this$props.storedValue;
      this.steps = (0, _createRangeSteps["default"])(fieldData, this.trackId);
      eventHandler.handleResize(storedValue, this.steps);
      this.setResizeListener();
    }
  }, {
    key: "setResizeListener",
    value: function setResizeListener() {
      var _this2 = this;

      window.addEventListener('resize', function () {
        var _this2$props = _this2.props,
            fieldData = _this2$props.fieldData,
            eventHandler = _this2$props.eventHandler,
            storedValue = _this2$props.storedValue;
        _this2.steps = (0, _createRangeSteps["default"])(fieldData, _this2.trackId);
        eventHandler.handleResize(storedValue, _this2.steps);

        _this2.setState({
          viewPortWidth: window.innerWidth // eslint-disable-line react/no-unused-state

        });
      });
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      var _this$props2 = this.props,
          eventHandler = _this$props2.eventHandler,
          fieldData = _this$props2.fieldData;
      this.steps = (0, _createRangeSteps["default"])(fieldData, this.trackId);
      event.preventDefault();
      eventHandler.onMouseDown(event, this.steps, this.handleId, this.trackId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          storedValue = _this$props3.storedValue,
          fieldData = _this$props3.fieldData,
          classPrefix = _this$props3.classPrefix,
          eventHandler = _this$props3.eventHandler,
          active = _this$props3.active,
          currentHandlePosition = _this$props3.currentHandlePosition,
          customControlRenderer = _this$props3.customControlRenderer;

      if (customControlRenderer) {
        var customControlRendererBound = customControlRenderer.bind(this);
        return customControlRendererBound(_objectSpread(_objectSpread({}, this.props), {}, {
          dependencies: {
            Input: _Input["default"],
            Track: _Track["default"],
            Ticks: _Ticks["default"],
            Handle: _Handle["default"]
          }
        }));
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__wrapper")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__label")
      }, fieldData.label), fieldData.instructions && /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__instructions")
      }, fieldData.instructions), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
        fieldData: fieldData,
        storedValue: storedValue,
        eventHandler: eventHandler,
        steps: this.steps
      }), /*#__PURE__*/_react["default"].createElement(_Track["default"], {
        trackId: this.trackId,
        classPrefix: classPrefix,
        currentHandlePosition: currentHandlePosition,
        handleMouseDown: this.handleMouseDown
      }, /*#__PURE__*/_react["default"].createElement(_Ticks["default"], {
        steps: this.steps,
        classPrefix: classPrefix
      }), /*#__PURE__*/_react["default"].createElement(_Handle["default"], {
        fieldData: fieldData,
        handleId: this.handleId,
        currentHandlePosition: currentHandlePosition,
        storedValue: storedValue,
        classPrefix: classPrefix,
        active: active
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__label-row")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__label-min")
      }, fieldData.control.options.minLabel), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(classPrefix, "__label-max")
      }, fieldData.control.options.maxLabel)));
    }
  }]);
  return RangeInputControl;
}(_react.Component);

exports.RangeInputControl = RangeInputControl;
RangeInputControl.displayName = 'RangeInputControl';
RangeInputControl.propTypes = {
  storedValue: _propTypes["default"].number.isRequired,
  complete: _propTypes["default"].bool.isRequired,
  // eslint-disable-line
  classPrefix: _propTypes["default"].string.isRequired,
  currentHandlePosition: _propTypes["default"].number.isRequired,
  active: _propTypes["default"].bool.isRequired,
  eventHandler: _propTypes["default"].shape({
    onChange: _propTypes["default"].func.isRequired
  }).isRequired,
  fieldData: _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    fieldKey: _propTypes["default"].string.isRequired,
    label: _propTypes["default"].string.isRequired,
    options: _propTypes["default"].array.isRequired,
    validation: _propTypes["default"].shape({
      message: _propTypes["default"].string.isRequired,
      pattern: _propTypes["default"].string.isRequired
    }).isRequired,
    value: _propTypes["default"].any.isRequired
  }).isRequired,
  customControlRenderer: _propTypes["default"].func
};
RangeInputControl.defaultProps = {
  customControlRenderer: null
};

var _default = (0, _index["default"])(RangeInputControl, _validator["default"], _EventHandler["default"], {
  active: false,
  viewPortWidth: window.innerWidth,
  currentHandlePosition: 0
});

exports["default"] = _default;